import * as _ from 'lodash';
export function filterItems(items: any[], props: string[], query: string, filter: 'contains' | 'startWith') {
  let results = [];
  if (items && items.length > 0) {
    if (query) {
      // search in provided items
      if (props && props.length > 0) {
        // querys are case sensitive
        const searchquerys = props;
        results = items.filter(item => {
          if (filter == 'startWith')
            return searchquerys.some(searchquery => _.get(item, searchquery) && _.get(item, searchquery).toLowerCase().indexOf(query) == 0);
          else {
            return searchquerys.some(searchquery => _.get(item, searchquery) && _.get(item, searchquery).toLowerCase().indexOf(query) >= 0);
          }
        });
      }
      else {
        results = items.filter(item => {
          if (filter == 'startWith')
            return item.indexOf && item.toLowerCase().indexOf(query) == 0;
          else {
            return item.indexOf && item.toLowerCase().indexOf(query) >= 0;
          }
        });
      }
    }
    else {
      results = items;
    }
  }
  else {
    results = [];
  }
  return results;
}
